import { MaintenanceStateInfo } from '@mp/system/maintenance/domain';

import { nextTransitionTimestamp } from './next-transition-timestamp';
import { parseUtcTimestamp } from './parse-utc-timestamp';

/**
 * Returns the milliseconds until the maintenance state changes according to the known window.
 *
 * An announced window transitions at its start, a running window at its end. The value can be negative
 * when the timestamp has already passed but the server has not confirmed the new state yet.
 * @param stateInfo The last known maintenance state.
 * @param correctedNow The current time (epoch milliseconds) corrected by the server time offset.
 * @returns The milliseconds until the next transition or `null` when no transition is known.
 */
export function msUntilNextTransition(stateInfo: MaintenanceStateInfo, correctedNow: number): number | null {
  const target = parseUtcTimestamp(nextTransitionTimestamp(stateInfo));

  return target === null ? null : target - correctedNow;
}
